module.exports = __webpack_public_path__ + "img/badge.ee93bf98.png";